import { useEffect } from 'react';

import { useLocation } from '@reach/router';
import { isNotSSR } from '@utils';

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		if (isNotSSR) {
			window.scrollTo(0, 0);
		}
	}, [pathname]);

	return null;
};

export default ScrollToTop;
